import * as actions from './tailoringTrialType/actions'
import * as mutations from './tailoringTrialType/mutations'
import * as getters from './tailoringTrialType/getters'

import { dataProps } from './tailoringTrialType/properties'

const state = {
    list: [],
    props: JSON.parse(JSON.stringify(dataProps))
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/tailoringTrialType.js